export enum ProductView {
  GRID = "Grid",
  LIST = "List",
}

export enum SortMethods {
  ByFeatured = "Featured",
  ByNewest = "Newest",
  ByPriceDesc = "Price: High - Low",
  ByPriceAsc = "Price: Low - High",
}

export enum FilterType {
  CHECKBOX = "Checkbox",
  SLIDER = "Slider",
}

export const productFilters = [
  "overallLength",
  "diameter",
  "bellDiameter",
  "interiorLength",
  "interiorWidth",
  "interiorTotalDepth",
  "bodyLength",
  "bodyWidth",
  "bodyDepth",
  "upperBout",
  "lowerBout",
  "totalSpaceUnits",
  "rackUnits",
  "railToRail",
  "price",
  "removableRack",
  "builtInShocks",
  "builtInWheelsOrCasters",
  "series",
  "interiors",
  "exterior",
  "color",
]

export const productSliderFilters = [
  "Overall Length",
  "Diameter",
  "Bell Diameter",
  "Interior Length",
  "Interior Width",
  "Interior Depth",
  "Interior Total Depth",
  "Body Length",
  "Body Width",
  "Body Depth",
  "Upper Bout",
  "Lower Bout",
  "Rack Units",
  "Rail To Rail",
  "Front Rail to Back Lid",
  "Filter by Price",
]

export const booleanFilters = [
  "Removable Rack",
  "Built In Shocks",
  "Built In Wheels Or Casters",
]

export const filterPropMap: any = {
  "Overall Length": { prop: "overallLength" },
  Diameter: { prop: "diameter" },
  "Bell Diameter": { prop: "bellDiameter" },
  "Interior Length": { prop: "interiorLength" },
  "Interior Width": { prop: "interiorWidth" },
  "Interior Total Depth": { prop: "interiorTotalDepth" },
  "Body Length": { prop: "bodyLength" },
  "Body Width": { prop: "bodyWidth" },
  "Body Depth": { prop: "bodyDepth" },
  "Upper Bout": { prop: "upperBout" },
  "Lower Bout": { prop: "lowerBout" },
  "Rack Units": { prop: "rackUnits" },
  "Rail To Rail": { prop: "railToRail" },
  "Front Rail to Back Lid": { props: ["railToRail", "frontRailToBackLid"] },
  "Filter by Price": { prop: "price", isCurrency: true },
  "Removable Rack": { prop: "removableRack" },
  "Built In Shocks": { prop: "builtInShocks" },
  "Built In Wheels Or Casters": { prop: "builtInWheelsOrCasters" },
  Features: { prop: "" },
  Series: { prop: "series" },
  Interior: { prop: "interior" },
  Exterior: { prop: "exterior" },
  Color: { prop: "color" },
}

export const filtersByProductType = {
  rack: [
    "rackUnits",
    "railToRail",
    "frontRailToBackLid",
    "price",
    "removableRack",
    "builtInShocks",
    "builtInWheelsOrCasters",
    "series",
    "exterior",
    "colors",
  ],
  flyRacks: [
    "rackUnits",
    "railToRail",
    "price",
    "builtInWheelsOrCasters",
    "series",
    "colors",
  ],
  standardCases: [
    "interiorLength",
    "interiorWidth",
    "interiorTotalDepth",
    "price",
    "builtInWheelsOrCasters",
    "series",
    "interiors",
    "exterior",
    "colors",
  ],
  cylindricalCases: [
    "diameter",
    "interiorTotalDepth",
    "price",
    "builtInWheelsOrCasters",
    "series",
    "exterior",
    "colors",
  ],
  stringProduct: [
    "bodyLength",
    "bodyWidth",
    "bodyDepth",
    "upperBout",
    "lowerBout",
    "price",
    "builtInWheelsOrCasters",
    "series",
    "exterior",
    "colors",
  ],
  wind: [
    "overallLength",
    "bellDiameter",
    "price",
    "builtInWheelsOrCasters",
    "series",
    "exterior",
    "colors",
  ],
  accessory: ["price", "colors"],
}
